import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import driver from "./modules/driver";
import ordersList from "./modules/ordersList";
import ordersDetails from "./modules/ordersDetails";
import returnGoodsList from "./modules/returnGoodsList";
import productsList from "./modules/productsList";
import extraList from "./modules/extraList";
import nonDelivery from "./modules/nonDelivery";
import listILT from "./modules/ListILT";
import compartmentList from "./modules/compartmentList";
import speciesList from "./modules/speciesList";
import summaryList from "./modules/summaryList";
import confirmOrder from "./modules/confirmOrder";
import compartments from "./modules/compartments";
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const debug = true;

export default new Vuex.Store({
    modules: {
        auth,
        driver,
        ordersList,
        ordersDetails,
        returnGoodsList,
        extraList,
        productsList,
        nonDelivery,
        listILT,
        compartmentList,
        speciesList,
        summaryList,
        confirmOrder,
        compartments
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => sessionStorage.getItem(key),
                setItem: (key, value) => sessionStorage.setItem(key, value),
                removeItem: key => sessionStorage.removeItem(key)
            }
        })],
    strict: debug
});
